import React, { useState, useEffect } from "react";
import Layout from "components/yenimahalle/Layout.js";
import ContentHeader from "components/yenimahalle/ContentHeader";
import routing_1 from "../../images/yenimahalle/bilgi_edinme_1.jpg";

import { CustomForm, CustomSelect } from "albinasoft-ui-package";
import "../../assets/css/main.css";

// İlgili input tipi ve form element tipi importları
import { ElementType } from "albinasoft-ui-package/dist/components/CustomForm";
import { InputType } from "albinasoft-ui-package/dist/components/CustomInput";
import { AllowedTypes } from "albinasoft-ui-package/dist/components/CustomFileUploader";

function BilgiEdinme() {
  // Seçilen başvuru tipini tutan state (opt1: Gerçek, opt2: Tüzel)
  const [selectedOption, setSelectedOption] = useState("");
  const [pendingFileCount, setPendingFileCount] = useState(0);

  // Form değerleri: Gerçek ve Tüzel başvurulara ait ayrı alan dizileri
  const [formValues, setFormValues] = useState<Record<string, any>>({
    formValuesForGercek: {
      isimSoyisim: "",
      email: "",
      telefon: "",
      iletisimAdresi: "",
      fax: "",
      tcKimlik: "",
      istenilenBilgi: "",
    },
    formValuesForTuzel: {
      unvan: "",
      emailTuzel: "",
      telefonTuzel: "",
      iletisimAdresiTuzel: "",
      faxTuzel: "",
      yetkiliTcKimlik: "",
      fileBelge: null,
      istenilenBilgi: "",
    },

    fileNames: [] as string[]
  });

  // Nested form değerlerini güncellemek için handleInputChange fonksiyonu
  const handleInputChange =
    (formId: "formValuesForGercek" | "formValuesForTuzel") =>
      (id: string) =>
        (e: Date | null | React.ChangeEvent<any>) => {
          setFormValues((prev) => {
            const updatedForm = { ...prev[formId] };
            if (e instanceof Date || e === null) {
              updatedForm[id] = e;
            } else if (e.target) {
              const { type, checked, value, files } = e.target;
              if (type === "file") {
                updatedForm[id] = files[0];
              } else {
                updatedForm[id] = type === "checkbox" ? checked : value;
              }
            } else {
              updatedForm[id] = e;
            }
            return {
              ...prev,
              [formId]: updatedForm,
            };
          });
        };

  // Dosya yükleme ve silme işlemleri için callback'ler (tüzel form için)
  const handleFilesUploaded = (uploadedFileNames: string[]) => {
    setFormValues((prev) => ({
      ...prev,
      formValuesForTuzel: {
        ...prev.formValuesForTuzel,
        // Çoklu dosya yüklemesi yerine ilk dosya alınır
        fileBelge: uploadedFileNames[0],
      },
    }));
  };

  const handleRemoveUploaded = (fileName: string) => {
    setFormValues((prev) => ({
      ...prev,
      formValuesForTuzel: {
        ...prev.formValuesForTuzel,
        fileBelge: null,
      },
    }));
  };

  // Form gönderim işlemi: Sadece seçili formun değerleri gönderilir
  const handleSubmit = (submittedValues: Record<string, any>) => {
    let completeValues: Record<string, any> = {};
    if (selectedOption === "opt1") {
      completeValues = formValues.formValuesForGercek;
    } else if (selectedOption === "opt2") {
      completeValues = formValues.formValuesForTuzel;
    }
    console.log("Form Submitted with:", completeValues);
    alert("Form gönderildi.");
  };

  // İptal butonuna tıklandığında ilgili formun görünürlüğünü kapatır.
  const handleCancel = (formName: string) => {
    console.log(`Cancel clicked for ${formName}`);
    setFormVisibility((prevState) => ({
      ...prevState,
      [formName]: false,
    }));
  };

  // Gerçek Kişi form elemanları
  const gercekFormElements = [
    {
      id: "isimSoyisim",
      type: ElementType.INPUT,
      inputType: InputType.TEXT,
      label: "İsim Soyisim",
      value: formValues.formValuesForGercek.isimSoyisim,
      required: true,
      onChange: handleInputChange("formValuesForGercek")("isimSoyisim"),
    },
    {
      id: "email",
      type: ElementType.INPUT,
      inputType: InputType.EMAIL,
      label: "E-Posta Adresi",
      value: formValues.formValuesForGercek.email,
      required: true,
      onChange: handleInputChange("formValuesForGercek")("email"),
    },
    {
      id: "telefon",
      type: ElementType.INPUT,
      inputType: InputType.TEL,
      label: "Telefon Numarası",
      value: formValues.formValuesForGercek.telefon,
      required: true,
      onChange: handleInputChange("formValuesForGercek")("telefon"),
    },
    {
      id: "iletisimAdresi",
      type: ElementType.TEXTAREA,
      label: "İletişim Adresi",
      value: formValues.formValuesForGercek.iletisimAdresi,
      required: true,
      onChange: handleInputChange("formValuesForGercek")("iletisimAdresi"),
    },
    {
      id: "fax",
      type: ElementType.INPUT,
      inputType: InputType.TEL,
      label: "Fax",
      value: formValues.formValuesForGercek.fax,
      onChange: handleInputChange("formValuesForGercek")("fax"),
    },
    {
      id: "tcKimlik",
      type: ElementType.INPUT,
      inputType: InputType.NUMBER,
      label: "TC Kimlik Numarası",
      value: formValues.formValuesForGercek.tcKimlik,
      required: true,
      onChange: handleInputChange("formValuesForGercek")("tcKimlik"),
    },
    {
      id: "dividerGercek",
      style: { marginTop: "0.5rem", marginBottom: "0.5rem" },
      type: ElementType.DIVIDER,
      value: "",
    },
    {
      id: "infoTextGercek",
      type: ElementType.TEXT,
      value:
        "4982 sayılı Bilgi Edinme Hakkı Kanunu gereğince istediğim bilgi ve belgeler aşağıda belirtilmiştir. Gereğini arz ederim",
    },
    {
      id: "dividerGercek2",
      style: { marginTop: "0.5rem", marginBottom: "0.5rem" },
      type: ElementType.DIVIDER,
      value: "",
    },
    {
      id: "istenilenBilgi",
      type: ElementType.TEXTAREA,
      label: "İstenilen Bilgi ve Belgeler",
      value: formValues.formValuesForGercek.istenilenBilgi,
      required: true,
      onChange: handleInputChange("formValuesForGercek")("istenilenBilgi"),
    },
  ];

  // Tüzel Kişi form elemanları
  const tuzelFormElements = [
    {
      id: "unvan",
      type: ElementType.INPUT,
      inputType: InputType.TEXT,
      label: "Ünvan",
      value: formValues.formValuesForTuzel.unvan,
      required: true,
      onChange: handleInputChange("formValuesForTuzel")("unvan"),
    },
    {
      id: "emailTuzel",
      type: ElementType.INPUT,
      inputType: InputType.EMAIL,
      label: "E-Posta Adresi",
      value: formValues.formValuesForTuzel.emailTuzel,
      required: true,
      onChange: handleInputChange("formValuesForTuzel")("emailTuzel"),
    },
    {
      id: "telefonTuzel",
      type: ElementType.INPUT,
      inputType: InputType.TEL,
      label: "Telefon Numarası",
      value: formValues.formValuesForTuzel.telefonTuzel,
      required: true,
      onChange: handleInputChange("formValuesForTuzel")("telefonTuzel"),
    },
    {
      id: "iletisimAdresiTuzel",
      type: ElementType.TEXTAREA,
      label: "İletişim Adresi",
      value: formValues.formValuesForTuzel.iletisimAdresiTuzel,
      required: true,
      onChange: handleInputChange("formValuesForTuzel")("iletisimAdresiTuzel"),
    },
    {
      id: "faxTuzel",
      type: ElementType.INPUT,
      inputType: InputType.TEL,
      label: "Fax",
      value: formValues.formValuesForTuzel.faxTuzel,
      onChange: handleInputChange("formValuesForTuzel")("faxTuzel"),
    },
    {
      id: "yetkiliTcKimlik",
      type: ElementType.INPUT,
      inputType: InputType.NUMBER,
      label: "Yetkili TC Kimlik Numarası",
      value: formValues.formValuesForTuzel.yetkiliTcKimlik,
      required: true,
      onChange: handleInputChange("formValuesForTuzel")("yetkiliTcKimlik"),
    },
    {
      id: "fileBelge",
      type: ElementType.FILEUPLOADER,
      label: "Yetkili Olduğunuzu Gösterir Belge (PDF Dosyası Olmalıdır)",
      url: "https://yenimahalle-cc-api.alsft.com/api/Portal/UploadAttachForCitizenRequestOverWeb",
      multi: true,
      allowedTypes: AllowedTypes.FILE,
      maxFile: 10,
      maxSize: 10 * 1024 * 1024, // 10 MB
      onUploadComplete: handleFilesUploaded,
      onRemoveUploaded: handleRemoveUploaded,
      onPendingChange: setPendingFileCount,
      value: formValues.formValuesForTuzel.fileBelge,
      onChange: handleInputChange("formValuesForTuzel")("fileBelge"),
    },
    {
      id: "dividerTuzel",
      style: { marginTop: "0.5rem", marginBottom: "0.5rem" },
      type: ElementType.DIVIDER,
      value: "",
    },
    {
      id: "infoTextTuzel",
      type: ElementType.TEXT,
      value:
        "4982 sayılı Bilgi Edinme Hakkı Kanunu gereğince istediğim bilgi ve belgeler aşağıda belirtilmiştir. Gereğini arz ederim",
    },
    {
      id: "dividerTuzel2",
      style: { marginTop: "0.5rem", marginBottom: "0.5rem" },
      type: ElementType.DIVIDER,
      value: "",
    },
    {
      id: "istenilenBilgi",
      type: ElementType.TEXTAREA,
      label: "İstenilen Bilgi ve Belgeler",
      value: formValues.formValuesForTuzel.istenilenBilgi,
      required: true,
      onChange: handleInputChange("formValuesForTuzel")("istenilenBilgi"),
    },
  ];

  // Seçime bağlı olarak hangi formun gösterileceğini belirleyen form konfigürasyon dizisi
  let formConfigs: {
    key: string;
    elements: any;
    showConfirmButton: boolean;
    showCancelButton: boolean;
    confirmLabel: string;
    cancelLabel: string;
  }[] = [];

  if (selectedOption === "opt1") {
    formConfigs = [
      {
        key: "Gerçek Kişi Başvurusu",
        elements: gercekFormElements,
        showConfirmButton: true,
        showCancelButton: false,
        confirmLabel: "Gönder",
        cancelLabel: "Kapat",
      },
    ];
  } else if (selectedOption === "opt2") {
    formConfigs = [
      {
        key: "Tüzel Kişi Başvurusu",
        elements: tuzelFormElements,
        showConfirmButton: true,
        showCancelButton: false,
        confirmLabel: "Gönder",
        cancelLabel: "Kapat",
      },
    ];
  }

  // Seçim değiştiğinde ilgili formun görünürlüğünü varsayılan olarak aktif hale getir
  const [formVisibility, setFormVisibility] = useState<Record<string, boolean>>({});
  useEffect(() => {
    const newVisibility: Record<string, boolean> = {};
    formConfigs.forEach((config) => {
      newVisibility[config.key] = true;
    });
    setFormVisibility(newVisibility);
  }, [selectedOption]);

  return (
    <Layout>
      <ContentHeader
        headingLine1="Bilgi Edinme"
        headingLine2="Formu"
        topNotification=""
        bottomNotification=""
        primaryButtonUrl=""
        primaryButtonText=""
        secondaryButtonUrl=""
        secondaryButtonText=""
        photoUrl={routing_1}
        videoUrl=""
      />

      <div
        className="d-flex flex-column align-items-center mt-5"
        style={{ minHeight: "250px" }}
      >
        {/* Başvuru tipi seçimi */}
        <CustomSelect
          label="Aşağıdaki Alandan Uygun Başvuru Tipini Seçiniz"
          options={[
            { id: "opt1", label: "Gerçek Kişi Başvurusu", value: "opt1" },
            { id: "opt2", label: "Tüzel Kişi Başvurusu", value: "opt2" },
          ]}
          value={selectedOption}
          onChange={(value: string | string[]) =>
            setSelectedOption(typeof value === "string" ? value : "")
          }
        />

        {/* Seçilen başvuru tipine göre form konfigürasyonlarını render et */}
        <div className="row w-50 mt-4">
          {formConfigs.map(
            ({
              key,
              elements,
              showConfirmButton,
              showCancelButton,
              confirmLabel,
              cancelLabel,
            }) =>
              formVisibility[key] ? (
                <div className="col-12" key={key}>
                  <div className="card">
                    <div className="card-header">{key}</div>
                    <div className="card-body">
                      <CustomForm
                        elements={elements}
                        confirmLabel={`${key} ${confirmLabel}`}
                        cancelLabel={`${key} ${cancelLabel}`}
                        showConfirmButton={showConfirmButton}
                        showCancelButton={showCancelButton}
                        onSubmit={handleSubmit}
                        handleCancel={() => handleCancel(key)}
                      />
                    </div>
                  </div>
                </div>
              ) : null
          )}
        </div>
      </div>
    </Layout>
  );
}

export default BilgiEdinme;
